import { useState, useEffect } from "react";
import { isAdmin, hasPermission, isMaster } from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";
import { StrategicAxesConfig } from "../../../components/Admin/ConfigForms/StrategicAxesConfig";
import { useSite } from "../../../contexts";
import { useAuth } from "../../../hooks";
import { Permission } from "../../../api";
import "./StrategicAxes.scss";

const permissionController = new Permission();

export function StrategicAxes() {
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const [siteSelected, setSiteSelected] = useState(null);
  const [permissionsByRole, setPermissionsByRole] = useState([]);

  const { site } = useSite();

  useEffect(() => {
    (async () => {
      setSiteSelected(site);
    })();
  }, [site]);

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role, accessToken]);

  if (
    isMaster(role) ||
    isAdmin(role) ||
    hasPermission(permissionsByRole, role._id, "configure", "view")
  ) {
    return (
      <div className="strategic-axes-page">
        <StrategicAxesConfig site={siteSelected} />
      </div>
    );
  } else {
    return <ErrorAccessDenied />;
  }
}
